import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import get from 'lodash/get';
import compact from 'lodash/compact';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreAlarmLogsReportWizardConfiguration',
  props: {
    reportModel: {
      type: Object,
      required: true
    },
    formValid: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      editModel: null,
      commands: [],
      executionResultPrompt: false,
      lastExecutionResult: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    reportExecuteConditions: function reportExecuteConditions() {
      if (this.editModel.filters.originType === 'smartgroup-packet-monitoring') {
        return [{
          value: 'newAlarms',
          text: this.$i18n_t('AlarmLogs.reports.wizard.conditions.newThresholdAlarms')
        }, {
          value: 'new',
          text: this.$i18n_t('AlarmLogs.reports.wizard.conditions.thresholdAlarms')
        }];
      }

      return [{
        value: 'newErrors',
        text: this.$i18n_t('AlarmLogs.reports.wizard.conditions.newErrors')
      }, {
        value: 'new',
        text: this.$i18n_t('AlarmLogs.reports.wizard.conditions.new')
      }, {
        value: 'activeErrors',
        text: this.$i18n_t('AlarmLogs.reports.wizard.conditions.activeErrors')
      }, {
        value: 'active',
        text: this.$i18n_t('AlarmLogs.reports.wizard.conditions.active')
      }];
    },
    localeOptions: function localeOptions() {
      return [{
        value: 'de-DE',
        text: this.$i18n_t('AlarmLogs.reports.wizard.locales.de-DE')
      }, {
        value: 'en-US',
        text: this.$i18n_t('AlarmLogs.reports.wizard.locales.en-US')
      }, {
        value: 'en-GB',
        text: this.$i18n_t('AlarmLogs.reports.wizard.locales.en-GB')
      }];
    },
    getColumnWidth: function getColumnWidth() {
      return function (param, paramConfig) {
        if (paramConfig.width && ['m', 'l'].indexOf(paramConfig.width) >= 0) {
          return param.width === 'm' ? 6 : 12;
        }

        return 4;
      };
    },
    weekDayOptions: function weekDayOptions() {
      return [{
        value: 1,
        text: this.$i18n_t('Common.Monday')
      }, {
        value: 2,
        text: this.$i18n_t('Common.Tuesday')
      }, {
        value: 3,
        text: this.$i18n_t('Common.Wednesday')
      }, {
        value: 4,
        text: this.$i18n_t('Common.Thursday')
      }, {
        value: 5,
        text: this.$i18n_t('Common.Friday')
      }, {
        value: 6,
        text: this.$i18n_t('Common.Saturday')
      }, {
        value: 0,
        text: this.$i18n_t('Common.Sunday')
      }];
    },
    monthDaysOptions: function monthDaysOptions() {
      var monthDays = Array.from({
        length: 31
      }, function (idx, i) {
        return i + 1;
      });
      return monthDays;
    },
    actionsN20CardClass: function actionsN20CardClass() {
      // in light-mode, the cards should have a slight darker-grey background,
      // in dark-mode they already have the appropriate separation
      return Boolean(this.$store.state.app.UiTheme) ? '' : 'dt-card-text-01';
    },
    tablesItems: function tablesItems() {
      return [{
        value: 'all',
        text: this.$i18n_t('Common.all')
      }, {
        value: 'overview',
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.overview')
      }, {
        value: 'newErrors',
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.newErrors')
      }, {
        value: 'newWarnings',
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.newWarnings')
      }, {
        value: 'activeErrors',
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.activeErrors')
      }, {
        value: 'activeWarnings',
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.activeWarnings')
      }, {
        value: 'resolvedErrors',
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.resolvedErrors')
      }, {
        value: 'resolvedWarnings',
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.resolvedWarnings')
      }];
    }
  }),
  watch: {
    reportModel: {
      handler: function handler() {
        this.editModel = cloneDeep(this.reportModel);
        this.handleTablesSelected(0);
      },
      deep: true,
      immediate: true
    },
    'editModel.tenantId': {
      handler: function handler() {
        this.fetchAccountRelatedData();
      },
      immediate: true
    },
    editModel: {
      handler: function handler() {
        // only publish changes if an actual value did change, not just a new cloned instance got assigned
        if (JSON.stringify(this.editModel) !== JSON.stringify(this.reportModel)) {
          this.publishChanges();
        }
      },
      deep: true
    }
  },
  methods: {
    fetchAccountRelatedData: function fetchAccountRelatedData() {
      var _this2 = this;

      if (!get(this.editModel, 'tenantId')) {
        return;
      }

      this.fetchBridges().then(function () {
        // clear incorrect parameters properties from actions (params should match command manifest definition)
        _this2.editModel.actions.forEach(function (action) {
          var definedParamsKeys = ['locale'].concat(_toConsumableArray(Object.keys(_this2.parametersForCommandId(action.command))));

          if (definedParamsKeys.length === 0) {
            return;
          }

          for (var key in action.params) {
            if (!definedParamsKeys.includes(key)) {
              delete action.params[key];
            }
          }
        });
      }).catch(function (error) {
        console.error('Error fetching bridges', error);

        _this2.$snack(_this2.$i18n_t('Connectors.Connectors.errors.errorWhileFetchingConnectos'), 'error');
      });
    },
    fetchBridges: function fetchBridges() {
      var _this3 = this;

      return Promise.all([ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes.filter(function (type) {
          // only display bridges that have instance commands
          // AND are of type mail (only valid action for reports, for now)
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0 && type.type === 'bridge-mail';
        });
      }), ApiService.getBridgesForTenant(this.editModel.tenantId)]).then(function (results) {
        var bridgeTypeIdx = 0;
        var bridgesIdx = 1;
        var commands = [];
        results[bridgesIdx].forEach(function (bridgeInstance) {
          var bridgeTypeDef = results[bridgeTypeIdx].find(function (bridgeDef) {
            return bridgeDef.type === bridgeInstance.type;
          });
          var instanceCmds = get(bridgeTypeDef, 'manifest.commands.instance', {});
          commands = commands.concat(Object.keys(instanceCmds).map(function (commandName) {
            if (instanceCmds[commandName].internal) {
              return null;
            }

            return _objectSpread(_objectSpread({}, instanceCmds[commandName]), {}, {
              name: "".concat(bridgeInstance.name, ".").concat(commandName),
              id: "".concat(bridgeInstance.id, ".").concat(commandName),
              bridgeType: bridgeInstance.type,
              config: get(bridgeInstance, 'bridge.config', {}),
              configId: bridgeInstance.id,
              manifest: bridgeTypeDef.manifest
            });
          }));
        });
        _this3.commands = compact(commands).filter(function (b) {
          var type = results[bridgeTypeIdx].find(function (t) {
            return t.type === b.bridgeType;
          });
          return get(type, 'manifest.functionScope.invokeDirection.outbound', false);
        });
      });
    },
    addReportAction: function addReportAction(index) {
      this.editModel.actions.splice(index, 0, {
        params: {
          subject: 'Alarmreport {{alarmReportName}} for {{smartGroupName}}',
          locale: 'en-US'
        },
        tables: ['all']
      });
      this.handleTablesSelected(index);
      this.editModel.actions = cloneDeep(this.editModel.actions);
    },
    deleteReportAction: function deleteReportAction(index) {
      pullAt(this.editModel.actions, [index]);
      this.editModel.actions = cloneDeep(this.editModel.actions);
    },
    testExecuteAction: function testExecuteAction(index) {
      var _this4 = this;

      ApiService.testAlarmReportAction(this, this.editModel, index).then(function (result) {
        _this4.lastExecutionResult = result;

        _this4.$snack(_this4.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionSuccessful'), 'success', {
          message: _this4.$i18n_t('Common.viewDetails'),
          click: function click() {
            _this4.executionResultPrompt = true;
          }
        });
      }).catch(function (error) {
        var errorRespData = get(error, 'response.data.data');
        var errorTranslation = errorRespData ? _this4.$i18n_t("Error.".concat(errorRespData)) : null;
        var errorDetails = errorRespData && errorTranslation !== "Error.".concat(errorRespData) ? errorTranslation : get(error, 'response.data.data');

        if (_typeof(errorDetails) === 'object') {
          errorDetails = JSON.stringify(errorDetails);
        }

        _this4.lastExecutionResult = get(error, 'response.data.message') ? "".concat(error.response.data.message, ": ").concat(errorDetails) : error.toString();

        _this4.$snack(_this4.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionFailed'), 'error', {
          message: _this4.$i18n_t('Common.viewDetails'),
          click: function click() {
            _this4.executionResultPrompt = true;
          }
        });
      });
    },
    commandAtIdxDidChange: function commandAtIdxDidChange(index) {
      var _this5 = this;

      var changedAction = this.editModel.actions[index];
      var newParamsKeys = Object.keys(this.parametersForCommandId(changedAction.command));
      changedAction.params = changedAction.params || {};
      var currentParamsKeys = Object.keys(changedAction.params);
      var keysToRemove = currentParamsKeys.filter(function (key) {
        return !newParamsKeys.includes(key);
      });
      keysToRemove.forEach(function (key) {
        delete _this5.editModel.actions[index].params[key];
      });
      var selectedCommand = this.editModel.actions[index];
      selectedCommand.params = selectedCommand.params || {};
    },
    findCommandById: function findCommandById(commandId) {
      return this.commands.find(function (c) {
        return c.id === commandId;
      });
    },
    orderedParamKeysForCommandId: function orderedParamKeysForCommandId(commandId) {
      var parameters = this.parametersForCommandId(commandId); // hardcoded filter here, assume (for now) all commands are "sendMail" commands
      // the body (html/text) will not be configurable, and display the subject separately

      return Object.keys(parameters).filter(function (p) {
        return ['subject', 'text', 'html'].indexOf(p) < 0;
      }).sort(function (a, b) {
        var orderIdxA = parameters[a].orderIdx || 0;
        var orderIdxB = parameters[b].orderIdx || 0;

        if (orderIdxA < orderIdxB) {
          return -1;
        }

        if (orderIdxA > orderIdxB) {
          return 1;
        }

        return a.localeCompare(b);
      });
    },
    parametersForCommandId: function parametersForCommandId(commandId) {
      return get(this.findCommandById(commandId), 'parameters', {});
    },
    startDatePicked: function startDatePicked(dateObject) {
      this.editModel.timeTrigger.dateStart = new Date(dateObject.from * 1000).toISOString();
    },
    endDatePicked: function endDatePicked(dateObject) {
      this.editModel.timeTrigger.dateEnd = new Date(dateObject.from * 1000).toISOString();
    },
    handleDaysSelection: function handleDaysSelection(property) {
      var days = this.editModel.timeTrigger[property] || [];
      this.editModel.timeTrigger[property] = days.filter(function (day) {
        return !isNaN(parseInt(day));
      });
    },
    handleTablesSelected: function handleTablesSelected(index) {
      if (this.editModel.actions[index].tables.find(function (i) {
        return i === 'all';
      })) {
        this.editModel.actions[index].tables = this.tablesItems.map(function (i) {
          return i.value;
        }).filter(function (i) {
          return i !== 'all';
        });
      }
    },
    publishChanges: debounce(function () {
      this.$emit('change', this.editModel);
    }, 250)
  }
};